// CSS Modules - component class name prefix: ContentTabs__

<template>
  <div :class="$style.container">
    <div v-if="!isMobile" :class="$style.tabs">
      <a
        v-for="(tab, index) in config.length"
        :key="`${index}-aKey`"
        v-on:click="updateTabs(tab)"
        :class="[
          $style.tab,
          { ContentTabs__active: activeTab === tab },
          { ContentTabs__disabled: config[index].disabled }
        ]"
      >
        {{ config[index].title }}
      </a>
      <div
        :class="[
          $style.content,
          { ContentTabs__activeContent: activeTab === tab }
        ]"
        v-for="(tab, index) in config.length"
        :key="`${index}-bKey`"
      >
        <div v-if="contentLoaded === false" :class="$style.preloadFilter"></div>
        <div
          v-if="
            activeTab === tab &&
              config[index].sliders &&
              config[index].sliders.length > 0
          "
        >
          <SidebarSlider :slides="config[index].sliders" />
        </div>
        <div v-else-if="activeTab === tab && config[index].FAQListConfig">
          <div
            v-for="(child, i) in html.children.length"
            :key="`${i}-childKey`"
          >
            <template
              v-if="
                html.children[i].outerHTML.includes('FAQList__container') ||
                  html.children[i].outerHTML.includes('faqList')
              "
            >
              <FAQList :config="config[index].FAQListConfig" />
            </template>
            <template v-else>
              <div v-html="html.children[i].outerHTML"></div>
            </template>
          </div>
        </div>
        <div v-else-if="activeTab === tab" v-html="content"></div>
      </div>
    </div>
    <div v-if="isMobile" :class="[$style.tabs, $style.mobile]">
      <div v-for="(tab, index) in config.length" :key="`${index}-cKey`">
        <a
          v-if="!config[index].disabled"
          v-on:click="updateTabs(tab)"
          :class="[
            $style.tab,
            { ContentTabs__active: activeTab === tab && mobileHidden !== tab }
          ]"
        >
          {{ config[index].title }}
        </a>
        <div
          :class="[
            $style.content,
            { ContentTabs__activeContent: activeTab === tab && !isMobile },
            {
              ContentTabs__activeContent:
                activeTab === tab && isMobile && mobileHidden !== tab
            }
          ]"
        >
          <div
            v-if="contentLoaded === false"
            :class="$style.preloadFilter"
          ></div>
          <div
            v-if="
              activeTab === tab &&
                config[index].sliders &&
                config[index].sliders.length > 0
            "
          >
            <SidebarSlider :slides="config[index].sliders" />
          </div>
          <div v-else-if="activeTab === tab && config[index].FAQListConfig">
            <div
              v-for="(child, i) in html.children.length"
              :key="`${i}-childKey`"
            >
              <template
                v-if="
                  html.children[i].outerHTML.includes('FAQList__container') ||
                    html.children[i].outerHTML.includes('faqList')
                "
              >
                <FAQList :config="config[index].FAQListConfig" />
              </template>
              <template v-else>
                <div v-html="html.children[i].outerHTML"></div>
              </template>
            </div>
          </div>
          <div v-else-if="activeTab === tab" v-html="content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SidebarSlider from "../SidebarSlider/SidebarSlider.vue";
import FAQList from "../FAQList/FAQList.vue";

export default {
  name: "ContentTabs",
  components: {
    SidebarSlider,
    FAQList
  },
  props: {
    config: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isMobile: false,
      activeTab: null,
      mobileHidden: null,
      content: null,
      contentLoaded: false,
      activeTabPreselected: false,
      html: null
    };
  },
  methods: {
    checkScreenSize() {
      window.innerWidth < 780
        ? (this.isMobile = true)
        : (this.isMobile = false);
    },
    updateTabs(tab) {
      const elm = event.currentTarget;
      if (!elm.classList.contains("ContentTabs__disabled")) {
        this.contentLoaded = false;
        if (this.config[tab - 1].url) {
          this.getContentFromUrl(this.config[tab - 1].url);
          this.content = "";
        } else if (this.config[tab - 1].sliders) {
          this.content = null;
          this.contentLoaded = true;
        } else if (this.config[tab - 1].id) {
          this.getContentFromId(this.config[tab - 1].id);
        } else {
          this.content = null;
        }
        if (
          this.isMobile &&
          this.activeTab === tab &&
          this.activeTab !== this.mobileHidden
        ) {
          this.mobileHidden = tab;
        } else if (
          this.isMobile &&
          this.activeTab === tab &&
          this.activeTab === this.mobileHidden
        ) {
          this.mobileHidden = null;
        } else if (this.isMobile && this.activeTab !== tab) {
          this.mobileHidden = null;
          this.activeTab = tab;
        } else {
          this.activeTab = tab;
        }
      }
    },
    getContentFromId(id) {
      this.html = document.getElementById(id);
      if (this.html) {
        this.content = this.html.innerHTML;
        this.contentLoaded = true;
      } else {
        this.content = null;
        this.contentLoaded = false;
      }
    },
    getContentFromUrl(url) {
      axios
        .get(url)
        .then(
          response => (
            (this.content = response.data), (this.contentLoaded = true)
          )
        )
        .catch(
          error => (
            // eslint-disable-next-line no-console
            console.log(error),
            (this.content = null),
            (this.contentLoaded = false)
          )
        );
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
    this.checkScreenSize();
    const queries = window.location.search.substring(1).split("&");
    let queryStringTabId = null;
    if (queries) {
      for (const query of queries) {
        if (query.includes("tab")) {
          queryStringTabId = query.split("=")[1];
        }
      }
    }

    for (const [index, tab] of this.config.entries()) {
      if (
        (queryStringTabId && queryStringTabId == index+1 && !tab.disabled) ||
        (tab.active && !tab.disabled)
      ) {
        this.activeTab = index + 1;
        this.activeTabPreselected = true;
        if (tab.url) {
          this.getContentFromUrl(tab.url);
        } else if (tab.sliders) {
          this.content = null;
          this.contentLoaded = true;
        } else if (tab.id) {
          this.getContentFromId(tab.id);
        }
      }
    }
    if (!this.activeTabPreselected) {
      this.activeTab = 1;
      if (this.config[0].url) {
        this.getContentFromUrl(this.config[0].url);
      } else if (this.config[0].sliders) {
        this.content = null;
        this.contentLoaded = true;
      } else if (this.config[0].id) {
        this.getContentFromId(this.config[0].id);
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.checkScreenSize);
  }
};
</script>

<style module lang="scss">
@import "./ContentTabs.scss";
</style>
